export const ArrowRightNoCircle = () => (
	<svg aria-hidden="true" width="11" height="8" viewBox="0 0 11 8" fill="currentColor">
		<path d="M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z" />
	</svg>
);
